enum ComponentThemeType {
	VinFast = "VinFast",
	Legacy = "Legacy",
}

export default ComponentThemeType;
